/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ActivityLoggingLogModel { 
    organizationId?: number;
    organizationMnemonic?: string | null;
    actorId?: string | null;
    actorName?: string | null;
    actorType?: string | null;
    eventMessage?: string | null;
    eventType?: string | null;
    eventResult?: string | null;
    severityLevel?: string | null;
    targetId?: string | null;
    targetName?: string | null;
    targetType?: string | null;
    attributes?: { [key: string]: string; } | null;
}

